<template>
    <div id="sidebar-wrapper">
        <div class="sidebar-heading"></div>
        <div class="list-group list-group-flush">
            <div class="sidebar-name">
                <div class="sidebar-user-icon">
                    <i class="fas fa-user-circle"></i>
                </div>
                <div class="sidebar-username">
                    <span> {{($store.getters.user) ? clientName($store.getters.user) : ''}} </span>
                </div>
            </div>
            <div class="setting-wrapper" v-if="$can(['view offers list'])">
                <div class="list-group-item list-group-item-action settings-trigger" v-on:click="submenuOffer = !submenuOffer">
                    <i class="fas fa-columns"></i>
                    <span> {{$t('menu.oferte')}} </span>
                    <i v-if="submenuOffer" class="fas fa-arrow-alt-circle-right settingsArrow"></i>
                    <i v-else class="fas fa-arrow-alt-circle-left settingsArrow"></i>
                </div>
                <div class="settings-dropdown" v-bind:class="{settingsActive:submenuOffer}">
                    <router-link to="/offers" class="settings-drop-item">
                        <i class="fas fa-list-ul"></i>
                        <span> {{$t('menu.oferte')}} </span>
                    </router-link>
                    <router-link to="/offers/create" class="settings-drop-item">
                        <i class="fas fa-plus-circle"></i>
                        <span> {{$t('menu.creeazaOferta')}} </span>
                    </router-link>
                    <router-link to="/offer-templates" class="settings-drop-item">
                        <i class="fas fa-file-alt"></i>
                        <span> {{$t('menu.sablonOferta')}} </span>
                    </router-link>
                    <router-link to="/offer-emails" class="settings-drop-item">
                        <i class="fas fa-file-alt"></i>
                        <span> Cerere oferta </span>
                    </router-link>
                </div>
            </div>
            <div class="setting-wrapper" v-if="$can(['view order list']) || $can(['create order'])">
                <div class="list-group-item list-group-item-action settings-trigger" v-on:click="submenuOrder = !submenuOrder">
                    <i class="fas fa-file-import"></i>
                    <span> {{$t('menu.comenzi')}} </span>
                    <i v-if="submenuOrder" class="fas fa-arrow-alt-circle-right settingsArrow"></i>
                    <i v-else class="fas fa-arrow-alt-circle-left settingsArrow"></i>
                </div>
                <div class="settings-dropdown" v-bind:class="{settingsActive:submenuOrder}">
                    <router-link to="/orders" class="settings-drop-item" v-if="$can(['view orders list'])">
                        <i class="fas fa-list-ul"></i>
                        <span> {{$t('menu.comenzi')}} </span>
                    </router-link>
                    <router-link to="/orders/create" class="settings-drop-item" v-if="$can(['create order'])">
                        <i class="fas fa-plus-circle"></i>
                        <span> {{$t('menu.adaugaComanda')}} </span>
                    </router-link>
                </div>
            </div>
            <router-link to="/invoices" class="list-group-item list-group-item-action" v-if="$can(['view invoices list'])">
                <i class="fas fa-file-invoice"></i>
                <span> Facturi  </span>
            </router-link>
            <router-link to="/contacts" class="list-group-item list-group-item-action" v-if="$can(['view contacts list'])">
                <i class="fas fa-address-book"></i>
                <span> {{$t('menu.contacte')}}  </span>
            </router-link>
            <router-link to="/products" class="list-group-item list-group-item-action" v-if="$can(['view products list'])">
                <i class="fas fa-th"></i>
                <span> {{$t('menu.produse')}}  </span>
            </router-link>
            <!--<div class="setting-wrapper">
                <div class="list-group-item list-group-item-action settings-trigger" v-on:click="submenuPrizes = !submenuPrizes">
                    <i class="fas fa-gifts"></i>
                    <span> {{$t('menu.recompense')}} </span>
                    <i v-if="submenuPrizes" class="fas fa-arrow-alt-circle-right settingsArrow"></i>
                    <i v-else class="fas fa-arrow-alt-circle-left settingsArrow"></i>
                </div>
                <div class="settings-dropdown" v-bind:class="{settingsActive:submenuPrizes}">
                    <router-link to="/orders" class="settings-drop-item" v-if="$can(['view prizes-status'])">
                        <i class="far fa-chart-bar"></i>
                        <span> {{$t('menu.statusRecompense')}} </span>
                    </router-link>
                    <router-link to="/prizes" class="settings-drop-item">
                        <i class="fas fa-gifts"></i>
                        <span> {{$t('menu.premii')}} </span>
                    </router-link>
                    <router-link to="/prizes/settings" class="settings-drop-item" v-if="$can(['view prizes-settings'])">
                        <i class="fas fa-sliders-h"></i>
                        <span> {{$t('menu.setariPremii')}} </span>
                    </router-link>
                    <router-link to="/prizes/requests" class="settings-drop-item" v-if="$can(['view prizes-request'])">
                        <i class="fas fa-sliders-h"></i>
                        <span> {{$t('menu.solicitari')}} </span>
                    </router-link>
                </div>
            </div>
            <div class="setting-wrapper" v-if="$can(['view services list'])">
                <div class="list-group-item list-group-item-action settings-trigger" v-on:click="submenuService = !submenuService">
                    <i class="fas fa-tools"></i>
                    <span> Service </span>
                    <i v-if="submenuService" class="fas fa-arrow-alt-circle-right settingsArrow"></i>
                    <i v-else class="fas fa-arrow-alt-circle-left settingsArrow"></i>
                </div>
                <div class="settings-dropdown" v-bind:class="{settingsActive:submenuService}">
                    <router-link to="/service/works" class="settings-drop-item">
                        <i class="fas fa-briefcase"></i>
                        <span> Adauga lucrare </span>
                    </router-link>
                    <router-link to="/service/calendar" class="settings-drop-item">
                        <i class="far fa-calendar-alt"></i>
                        <span> Calendar </span>
                    </router-link>
                    <router-link to="/service/vtp" class="settings-drop-item">
                        <i class="fas fa-users-cog"></i>
                        <span> Verificare Tehnica Periodica </span>
                    </router-link>
                    <router-link to="/service/pif" class="settings-drop-item">
                        <i class="fas fa-users-cog"></i>
                        <span> PIF </span>
                    </router-link>
                </div>
            </div>-->
            <!-- <router-link to="/services" class="list-group-item list-group-item-action" v-if="$can(['view services list'])">
                <i class="fas fa-boxes"></i>
                <span> {{$t('menu.servicii')}} </span>
            </router-link>
            <router-link to="/post-sale-services" class="list-group-item list-group-item-action" v-if="$can(['view services-ps list'])">
                <i class="fas fa-boxes"></i>
                <span> {{$t('menu.postServicii')}} </span>
            </router-link> -->
            <router-link to="/messages" class="list-group-item list-group-item-action" v-if="!($store.getters.user && $store.getters.user.roles.includes('admin'))">
                <i class="fas fa-envelope-open-text"></i>
                <span> {{$t('menu.mesaje')}} </span>
            </router-link>
            <router-link to="/complaints" class="list-group-item list-group-item-action" v-if="!($store.getters.user && $store.getters.user.roles.includes('admin'))">
                <i class="fas fa-exclamation-triangle"></i>
                <span> {{$t('menu.reclamatii')}} </span>
            </router-link>
            <div class="setting-wrapper" v-if="$can(['view clients list','view partners list','view employees list','view providers list'])">
                <div class="list-group-item list-group-item-action settings-trigger" v-on:click="submenuCRM = !submenuCRM">
                    <i class="fas fa-layer-group"></i>
                    <span> {{$t('menu.crm')}} </span>
                    <i v-if="submenuCRM" class="fas fa-arrow-alt-circle-right settingsArrow"></i>
                    <i v-else class="fas fa-arrow-alt-circle-left settingsArrow"></i>
                </div>
                <div class="settings-dropdown" v-bind:class="{settingsActive:submenuCRM}">
                    <router-link to="/employees" class="settings-drop-item" v-if="$can(['view employees list'])">
                        <i class="fas fa-list-ul"></i>
                        <span> {{$t('menu.angajati')}} </span>
                    </router-link>
                    <router-link to="/clients" class="settings-drop-item" v-if="$can(['view clients list'])">
                        <i class="fas fa-list-ul"></i>
                        <span> {{$t('menu.clienti')}} </span>
                    </router-link>
                    <router-link to="/partners" class="settings-drop-item" v-if="$can(['view partners list'])">
                        <i class="fas fa-list-ul"></i>
                        <span> {{$t('menu.parteneri')}} </span>
                    </router-link>
                    <router-link to="/providers" class="settings-drop-item" v-if="$can(['view providers list'])">
                        <i class="fas fa-list-ul"></i>
                        <span> {{$t('menu.furnizori')}} </span>
                    </router-link>
                    <router-link to="/crm-section-settings" class="settings-drop-item" v-if="$can(['view providers list'])">
                        <i class="fas fa-users-cog"></i>
                        <span> {{$t('menu.setariCRM')}} </span>
                    </router-link>
                </div>
            </div>
<!--            <router-link to="" class="list-group-item list-group-item-action">-->
<!--                <i class="fas fa-money-bill"></i>-->
<!--                <span> {{$t('menu.vanzari')}}  </span>-->
<!--            </router-link>-->
            <div class="setting-wrapper">
                <div class="list-group-item list-group-item-action settings-trigger" v-on:click="submenuSettings = !submenuSettings">
                    <i class="fas fa-cogs"></i>
                    <span> {{$t('menu.setari')}} </span>
                    <i v-if="submenuSettings" class="fas fa-arrow-alt-circle-right settingsArrow"></i>
                    <i v-else class="fas fa-arrow-alt-circle-left settingsArrow"></i>
                </div>
                <div class="settings-dropdown" v-bind:class="{settingsActive:submenuSettings}">
                    <router-link to="/settings" class="settings-drop-item" v-if="$can(['view global settings'])">
                        <i class="fas fa-cogs"></i>
                        {{$t('menu.setari')}}
                    </router-link>
                    <router-link to="/admins" class="settings-drop-item" v-if="$can(['view admins list'])">
                        <i class="fas fa-list-ul"></i>
                        {{$t('menu.listaAdmini')}}
                    </router-link>
                    <router-link to="/notification-settings" class="settings-drop-item">
                        <i class="fas fa-bell"></i>
                        {{$t('menu.setariAlerte')}}
                    </router-link>
                    <router-link to="/categories" class="settings-drop-item" v-if="$can(['view nivel1 list'])">
                        <i class="fas fa-sitemap"></i>
                        {{$t('menu.nivel1')}}
                    </router-link>
                    <router-link to="/subcategories" class="settings-drop-item" v-if="$can(['view nivel2 list'])">
                        <i class="fas fa-sitemap"></i>
                        {{$t('menu.nivel2')}}
                    </router-link>
                    <router-link to="/subtypes" class="settings-drop-item" v-if="$can(['view nivel3 list'])">
                        <i class="fas fa-sitemap"></i>
                        {{$t('menu.nivel3')}}
                    </router-link>
                    <router-link to="/counties" class="settings-drop-item" v-if="$can(['view counties list'])">
                        <i class="fas fa-city"></i>
                        {{$t('menu.judet')}}
                    </router-link>
                    <router-link to="/cities" class="settings-drop-item" v-if="$can(['view cities list'])">
                        <i class="fas fa-city"></i>
                        {{$t('menu.oras')}}
                    </router-link>
                    <router-link to="/roles" class="settings-drop-item" v-if="($store.getters.user && $store.getters.user.roles.includes('admin'))">
                        <i class="fas fa-user-tag"></i>
                        {{$t('menu.roles')}}
                    </router-link>
                </div>
            </div>
            <router-link to="/my-account" class="list-group-item list-group-item-action">
                <i class="fas fa-user-circle"></i>
                <span> {{$t('menu.contulMeu')}} </span>
            </router-link>
        </div>
    </div>
</template>
<script>

export default {
  name: 'Navbar',
  data () {
    return {
      submenuSettings: false,
      submenuCRM: false,
      submenuOffer: false,
      submenuService: false,
      submenuOrder: false,
      submenuPrizes: false
    }
  }
}
</script>
